const ButtonRound = (props) => {
    
    return (
        <a href={props.url} onClick={() => {window.location.href = props.url}} className={`btn mt-3 get_start_btn get_start_btn_${props.color}`}>{props.label}</a>
    );
  };
  
  export default ButtonRound;
  